/**
 * @module Flash
 * Usage:
 * 
 * - Add single message and open flash.
 * Flash.success('Flash for messages')
 * 
 * - Add multiple messages and open flash.
 * Flash.info('Flash for messages', false)
 * Flash.warning('Flash for messages', false)
 * Flash.open()
 */
const Flash = (() => {
  const LIFETIME = 2500
  const ANIMATIONTIME = 500
  let flashTimeout
  let flashContainer

  const close = () => {
    flashContainer.classList.remove('is-active')
    setTimeout(() => {
      flashContainer.innerHTML = ''
    }, ANIMATIONTIME)
  }

  const open = () => {
    if (flashTimeout) clearTimeout(flashTimeout)
    flashContainer.classList.add('is-active')
    flashTimeout = setTimeout(close, LIFETIME)
  }

  const addMessage = (key, message) => {
    flashContainer.innerHTML = `
      ${flashContainer.innerHTML}
      <div class="c-flash__message c-flash__message--${key}">
        ${message}
      </div>
    `
  }

  const success = (message, withOpen = true) => {
    addMessage('success', message)
    if (withOpen) open()
  }

  const danger = (message, withOpen = true) => {
    addMessage('danger', message)
    if (withOpen) open()
  }

  const warning = (message, withOpen = true) => {
    addMessage('warning', message)
    if (withOpen) open()
  }

  const info = (message, withOpen = true) => {
    addMessage('info', message)
    if (withOpen) open()
  }

  const init = () => {
    flashContainer = document.querySelector('.js-flash')
    if (!flashContainer || !flashContainer.hasChildNodes()) return

    setTimeout(open, 1000)
  }

  return {
    init,
    success,
    danger,
    warning,
    info,
    open,
    close
  }
})()

export default Flash



// WEBPACK FOOTER //
// app/javascript/scripts/components/Flash.js